var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinCapitalizacaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.332,4.641v12.234c0,0.258-0.129,0.387-0.387,0.387h-7.91h-7.84c-0.258,0-0.387-0.129-0.387-0.387V4.641 c0-0.328,0.117-0.615,0.352-0.861s0.516-0.381,0.844-0.404H5.66V2.004c0.023-0.352,0.158-0.65,0.404-0.896s0.545-0.369,0.896-0.369 c0.141,0,0.328,0.047,0.562,0.141l1.512,0.738l1.441-0.668c0.445-0.258,0.879-0.269,1.301-0.035 c0.422,0.234,0.645,0.598,0.668,1.09v1.371h3.621c0.328,0.023,0.609,0.153,0.844,0.387c0.234,0.234,0.363,0.516,0.387,0.844 L17.332,4.641z M1.547,16.488h7.137L8.648,3.762c0-0.093,0.047-0.188,0.141-0.281c0.07-0.07,0.152-0.105,0.246-0.105h2.637V2.004 c0-0.188-0.094-0.334-0.281-0.439s-0.363-0.1-0.527,0.018L9.211,2.355c-0.117,0.07-0.234,0.07-0.352,0L7.242,1.582 c-0.164-0.093-0.34-0.093-0.527,0C6.527,1.676,6.434,1.816,6.434,2.004v1.758c0,0.234-0.129,0.352-0.387,0.352H2.004 C1.699,4.161,1.547,4.336,1.547,4.641V16.488z M16.031,4.148H9.422V6.75h7.137V4.711v-0.07C16.559,4.312,16.383,4.148,16.031,4.148 z M16.559,16.488v-9H9.422v9H16.559z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinCapitalizacaoIcon);
export default __webpack_public_path__ + "static/media/zeppelin-capitalizacao-icon.83e6b9f2.svg";
export { ForwardRef as ReactComponent };